
























































































































































































/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { EventBus } from "../event-bus";
import { SystemConfig } from "@/models/Config"
import { Token } from "@/utils/Token";
import axios from "axios";
import LicenseModal from "./LicenseModal.vue";
import {License} from "@/models/License";


@Component({
  components: {
    LicenseModal,
  },
})
export default class ConfigModal extends Vue {
  @Prop() readonly value!: boolean;
  private licenseInfo: License=new License("",0);

  private config=new SystemConfig();
  private licenseModalFlag=false;

  private ipv4Rules=[
      (v: any) => !!v || "Is required",
      (v: any) =>
        /^\w+$/.test(v) || "Must be of the form xxx.xxx.xxx.xxx or https://x...x.com",
    ];
  private portRules=[
      (v: any) => !!v || "Is required",
      (v: any) =>
        /^\d{1,5}$/.test(v) || "Must be of the form number with 1-5 digits.",
   
    ];
  private isSaveEnabled = true;

  get show() {
    return this.value;
  }
  set show(value: boolean) {
    this.config.empty();
  }

  created() {
    //console.log("ekm createsd");

    EventBus.$on("openConfigModal", (config:SystemConfig,linfo:License) => {      
      this.config=config;
      this.licenseInfo=linfo;
      console.log("receive data port",typeof( this.config.ExchangeServerPort))

    });
        
    EventBus.$on("closeLicenseModal", (value: boolean) => {
      this.licenseModalFlag= value;
      this.licenseInfo.Version=this.$store.state.version;
    });

    //when usage socket receives message, emits to this event to refresh usage
    EventBus.$on("refreshUsage", (value: string,systemConf:SystemConfig) => {
      //this.config=systemConf;
      this.config.IpAddress= systemConf.IpAddress;
      this.config.CpuUsage= systemConf.CpuUsage;
      this.config.RamUsage= systemConf.RamUsage;
      this.config.DbServiceStatus= systemConf.DbServiceStatus;
      this.config.VpnServiceStatus= systemConf.VpnServiceStatus;
      this.config.HsmConnectivityStatus= systemConf.HsmConnectivityStatus;
      this.config.HsmConnectivityStatus2= systemConf.HsmConnectivityStatus2;

      if (this.config.ExchangeServerPort===0){
          this.config.ExchangeServerPort=systemConf.ExchangeServerPort;
          this.config.ExchangeServerAddress=systemConf.ExchangeServerAddress;
      }
    });
  }
  

  @Watch("config.ExchangeServerAddress")
  ipChanged() {
    this.ipv4Rules = [];
    this.isSaveEnabled = false;
   }

  @Watch("config.ExchangeServerPort")
  portChanged() {
    this.portRules = [];
    this.isSaveEnabled = false;
   }

// close modal and clear input fields
  private cancel(): void {
    this.show = false;
    this.config.empty();
    EventBus.$emit("closeConfigModal",false );   

  }

  private submitHandler(): void {
    

    /*this.emailRules=[
      (v: any) => !!v || "Email is required",
      (v: any) =>
        /^\w+([.-_]\w+)*@\w+([.-_]\w+)*(\.[a-zA-Z]{2,3})+$/.test(v) || "invalid email",
    ];*/
    //accepted:
    //aaa9.9-k_o@y8.comp.edu.com    ang.sfyr@gmail.com    ang_sftr@yahoo.gr   tei@uniwa.edu.gr    teia.l@unima.gpr

   

    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const self = this;
    setTimeout(function () {
      // In order for TypeScript to know which type is being used for form, we need to cast the value.
      const result = (
        self.$refs.form as Vue & {
          validate: () => boolean;
        }
      ).validate();
      console.log("result of validation:", result);
      if (result) {
        // successful validation 
        self.UpdateConfigFunction();
      } 
    });
  }

  //PUT("/api/config)
  private async UpdateConfigFunction(){
    const token = await Token.getTokenWithExpiry("token");
    const data={
      exchangeServerIp:this.config.ExchangeServerAddress,
      exchangeServerPort:this.config.ExchangeServerPort,
    };    
    typeof(this.config.ExchangeServerPort)=="number"?"":data.exchangeServerPort=parseInt(this.config.ExchangeServerPort);
    console.log("send data port",typeof( data.exchangeServerPort));
    //////EventBus.$emit("BeginLoader",null );   

    //path remains the same so as to find the file to rename
    axios({
      method: "put",
      withCredentials: true,
      url: `${process.env.VUE_APP_BASE_URL}/config`,
      data: data,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-type": "application/json",
      },
    })
      .then((response) => {
        ////EventBus.$emit("FinishLoader",null );   
        let flag=false;

        if (response.data.code == 401) {
          EventBus.$emit("LogOutEventBus", false);
        } else {
          if (response.data.code == 200) {
            flag=true;
          } 
        }
        const snackbarData = {
          text:
            flag === true
              ? "Config Updated."
              : "Error: Config not Updated.",
          color: flag === true ? "#4caf50" : "#2196f3",
          };
          EventBus.$emit("showSnackbar", snackbarData);
      })
      .catch((err) => {
        ////EventBus.$emit("FinishLoader",null );   

        console.log("error:", err);
      });
    }

  private OpenLicenseModal():void{
    this.licenseModalFlag=true;
    EventBus.$emit("openLicenseModal",this.licenseInfo );   


  }
 
}
